import { appendCountryCode } from './phoneUtils';

// create a sha256 hash from a string and returns an arrayBuffer
async function digestMessage(message) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const hash = await window.crypto.subtle.digest('SHA-256', data);
    return hash;
}

async function digestMessageToText(message) {
    const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
}

// adds the sha256_email_address and sha256_phone_number to the google dataLayer array
const gmtPhoneAndEmail = async (phone = '', email = '') => {
    if (!phone) {
        console.error('GTM Error: Phone number is required but was not provided');
    }
    if (!email) {
        console.error('GTM Error: Email is required but was not provided');
    }

    const appendedPhoneNumber = appendCountryCode(phone);

    dataLayer?.push({
        event: 'form',
        enhanced_conversion_data: {
            sha256_email_address: await digestMessageToText(email),
            sha256_phone_number: await digestMessageToText(appendedPhoneNumber),
        },
    });
};

export default gmtPhoneAndEmail;
